import { Label } from "@/components/ui/label";
import { useAvatarSelect } from "@/hooks/dashboard/useAvatarSelect";
import { AvatarItem } from "./AvatarItem";
import AddNewAvatar from "./AddNewAvatar";
import { useState } from "react";
import { AvatarFormDialog } from "./AvatarFormDialog";
import type { TAvatar } from "@/types/TAvatar";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function AvatarSelect() {
  const { t } = useTranslation();
  const {
    avatars,
    removeAvatar,
  } = useAvatarSelect();

  const [isFormDialogOpen, setIsFormDialogOpen] = useState(false);
  const [editingAvatar, setEditingAvatar] = useState<TAvatar | null>(null);

  // Check if weighted avatar selection is active
  const hasMultipleAvatars = avatars.length > 1;

  const openEditDialog = (avatar_id: string) => {
    const avatarToEdit = avatars.find(
      (avatar) => avatar.avatar_id === avatar_id,
    );
    if (avatarToEdit) {
      setEditingAvatar(avatarToEdit);
      setIsFormDialogOpen(true);
    }
  };

  return (
    <ControlWrapper>
      <div className={"flex items-center justify-between mb-2"}>
        <Label>{t('settings.avatarManagement')}</Label>
        <AddNewAvatar />
      </div>
      {hasMultipleAvatars && (
        <div className="text-xs text-muted-foreground mb-2 space-y-1">
          <p className="font-medium">{t('settings.randomSelectionActive')}</p>
          <p>{t('settings.percentagesExplanation')}</p>
        </div>
      )}
      {avatars.length === 0 ? (
        <div className="text-sm text-muted-foreground p-4 border rounded-md text-center">
          {t('settings.noAvatars')}
        </div>
      ) : (
        <div className="border rounded-md divide-y">
          {avatars
            .sort((a, b) => a.avatar_name.localeCompare(b.avatar_name))
            .map((avatar) => (
              <AvatarItem
                key={avatar.avatar_id}
                avatar={avatar}
                onRemove={removeAvatar}
                onEdit={() => openEditDialog(avatar.avatar_id)}
                allAvatars={avatars}
              />
            ))
          }
        </div>
      )}
      <AvatarFormDialog
        open={isFormDialogOpen}
        onOpenChange={setIsFormDialogOpen}
        avatar={editingAvatar}
      />
    </ControlWrapper>
  );
}
